<template>
  <div class="yh-page">
    <el-card class="pt-3" v-loading="loading" :element-loading-text="loadingText">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane :label="tabLabel.basic" name="basic" class="px-4 py-3">
        <el-form :rules="rules" ref="dataForm" :model="new_customer" label-position="right" label-width="160px">
          <el-row>
            <el-col :span="22">
              <el-divider content-position="left"><span class="title">会员基本信息</span></el-divider>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <!-- 客户类型 -->
              <el-form-item label="客户类型" prop="type">
                <el-select class="filter-item" v-model="new_customer.type" filterable placeholder="请选择客户类型">
                  <el-option v-for="(type, index) in type_list" :key="index" :label="type.value" :value="type.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <!-- 会员名称 -->
              <el-form-item label="会员名称" prop="name">
                <el-input v-model="new_customer.name" placeholder="请输入会员名称" @blur="handleNameChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 身份证明文件 -->
              <el-form-item label="身份证明文件" prop="attachments">
                <uploading-list v-if="pageStatus === 'action.add'" :file-list="cc_file_list"
                  :attachment-name="attachment_name"></uploading-list>
                <attachment-list v-if="pageStatus === 'action.edit' && new_customer.id !== undefined"
                  object-type="member.member" :object-id="new_customer.id" :file-list="cc_file_list"
                  :attachment-name="attachment_name"
                  @removed="loadFileList('member.member', new_customer.id)"></attachment-list>
                <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="证件类型" prop="cert_type">
                <el-select class="filter-item" v-model="new_customer.cert_type" filterable placeholder="请选择会员类型">
                  <el-option v-for="(type, index) in file_type_list" :key="index" :label="type.value" :value="type.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="证件号码" prop="cert_number">
                <el-input v-model="new_customer.cert_number" placeholder="请输入证件号码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证件有效期至" prop="cert_expired">
                <el-date-picker v-model="new_customer.cert_expired" type="date" value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions" placeholder="证件有效期至" class="w-100"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <!-- 手机号码 -->
              <el-form-item label="手机号码 " prop="mobile">
                <el-input v-model="new_customer.mobile" maxlength="11" placeholder="请输入手机号码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <!-- 电子邮箱-->
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="new_customer.email" placeholder="请输入电子邮箱地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="国籍" prop="nationality">
                <el-input v-model="new_customer.nationality" placeholder="请输入国籍"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <!-- 联系电话 -->
              <el-form-item label="（办公）电话" prop="phone">
                <el-input v-model="new_customer.phone" placeholder="请输入固定电话号码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <!-- 联系地址 -->
              <el-form-item label="联系地址" prop="address">
                <el-input v-model="new_customer.address" placeholder="请输入联系地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 邮编 -->
              <el-form-item label="邮编" prop="postcode">
                <el-input v-model="new_customer.postcode" maxlength="6" placeholder="请输入邮编"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 联系人信息 ------------------------------------------------------------------------------ -->
          <!--
          <el-row class="el-row-divider">
            <el-col :span="22">
              <el-divider content-position="left"><span class="title">联系人信息</span><span
                  class="highlight">(如无法取得会员电话,则务必填写联系人以及联系人的手机号或微信号码)</span></el-divider>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="联系人" prop="contact">
                <el-input v-model="new_customer.contact" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="联系人手机号" prop="contact_mobile">
                <el-input v-model="new_customer.contact_mobile" maxlength="11" placeholder="请输入联系人手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系人微信" prop="contact_persion_wechat">
                <el-input v-model="new_customer.contact_wechat" placeholder="请输入联系人微信号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          -->

          <!-- 公司类型会员附加信息------------------------------------------------------------------- -->
          <template v-if="new_customer.type === '0'">
            <el-row class="el-row-divider">
              <el-col :span="22">
                <el-divider content-position="left"><span class="title">公司类型会员附加信息</span></el-divider>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <!-- 行业类型 -->
                <el-form-item label="行业类型" prop="industry_type">
                  <el-input v-model="new_customer.industry_type" placeholder="请输入行业类型"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 实际控制人 -->
                <el-form-item label="实际控制人" prop="actual_controller">
                  <el-input v-model="new_customer.actual_controller" placeholder="请输入实际控制人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 成立时间 -->
                <el-form-item label="成立时间" prop="established_time">
                  <el-date-picker v-model="new_customer.established_time" type="year" value-format="yyyy" format="yyyy"
                    placeholder="请选择成立时间" class="w-100"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <!-- 工作区域 -->
                <el-form-item v-if="new_customer.type === '0'" label="工作区域" prop="work_area">
                  <el-input v-model="new_customer.work_area" placeholder="请输入工作区域"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 公司官网 -->
                <el-form-item label="公司官网" prop="site">
                  <el-input v-model="new_customer.site" placeholder="请输入公司官网"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 传真 -->
                <el-form-item label="传真" prop="fax">
                  <el-input v-model="new_customer.fax" placeholder="请输入传真"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="法人代表名称" prop="legal_representative">
                  <el-input v-model="new_customer.legal_representative" placeholder="请输入法人代表名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>


          <!-- 个人类型会员附加信息------------------------------------------------------------------- -->
          <template v-if="new_customer.type === '1'">
            <el-row class="el-row-divider">
              <el-col :span="22">
                <el-divider content-position="left"><span class="title">个人类型会员附加信息</span></el-divider>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="5">
                <!-- 性别 -->
                <el-form-item label="性别" prop="gender">
                  <el-radio-group v-model="new_customer.gender">
                    <el-radio v-for="gender in gender_list" :key="gender.code" :label="gender.code">{{ gender.value }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 出生日期 -->
                <el-form-item label="出生日期" prop="birthday">
                  <el-date-picker v-model="new_customer.birthday" type="date" value-format="yyyy-MM-dd" placeholder="出生日期"
                    class="w-100"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <!-- 会员职业 -->
                <el-form-item label="职业" prop="occupation">
                  <el-input v-model="new_customer.occupation" placeholder="请输入会员职业"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 家庭电话 -->
                <el-form-item label="家庭电话" prop="home_phone">
                  <el-input v-model="new_customer.home_phone" placeholder="请输入家庭电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <!-- 船舶申请信息------------------------------------------------------------------- -->
          <template v-if="opear_type == 'CreateShipApply'">
            <el-row class="el-row-divider">
              <el-col :span="22">
                <el-divider content-position="left"><span class="title">船舶申请信息</span></el-divider>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-row>
                  <el-col :span="9">
                    <el-form-item label="请选择要入会的船舶" prop="ship">
                      <el-select v-model="form.ship" placeholder="请选择船舶" filterable @change="handleShipInfo"
                        value-key="id" remote :remote-method="remoteShipMethod" :loading="ship_loading">
                        <el-option v-for="s in ships" :key="s.id" :label="s.name" :value="s.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-button size="small" type="primary" @click="addAppShip()">添加申请船舶</el-button>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-form-item label="已选择申请船舶" prop="apply_ships" style="width: 80%">
                  <el-table :data="apply_ships" border style="width: 58%">

                    <el-table-column prop="id" label="船id" width="180">
                    </el-table-column>
                    <el-table-column prop="name" label="船名" width="180">
                    </el-table-column>
                    <el-table-column align="left" label="操作" width="200px">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                          <el-button type="text" @click="handleDelete(scope.row)"><i
                              class="el-icon-delete"></i></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <el-row class="el-row-divider">
            <el-col :span="22">
              <el-divider content-position="left"><span class="title">其他信息</span></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <!-- 备注 -->
              <el-form-item label="备注" prop="remark" style="width: 80%">
                <el-input type="textarea" :rows="4" placeholder="请输入备注信息" v-model="new_customer.remark">
                </el-input>
              </el-form-item>
              <el-form-item label="拒绝原因" v-if="new_customer.status === 3" style="width: 80%">
                  <el-input type="text" :rows="4" v-model="new_customer.refuse_reason" disabled />
              </el-form-item>
              <el-form-item label="风险准备金账户" prop="ship_info" style="width: 80%">
                <el-input placeholder="输入船名进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
                  <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                  <el-button slot="append" type="primary" icon="el-icon-circle-plus-outline"  @click="handleSubmitShipQuitApply">申请退会</el-button>
                </el-input>
                <el-table v-loading="searching" :data="ship_info" border style="width: 100%"  @selection-change="handleSelectionChangeAccount">
                  <el-table-column align="left" type="selection" width="50px"></el-table-column>
                  <el-table-column prop="id" label="账户id" width="80px">
                  </el-table-column>
                  <el-table-column prop="account" label="账户" width="180">
                  </el-table-column>
                  <el-table-column prop="ship_name" label="绑定船">
                  </el-table-column>
                  <el-table-column prop="status_name" label="船舶状态">
                  </el-table-column>
                  <el-table-column prop="apply_date" label="最近一期保单的起止时间">
                  </el-table-column>
                  <el-table-column prop="balance" label="余额">
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间">
                  </el-table-column>

                  <el-table-column align="left" label="操作" width="200px">
                    <template slot-scope="scope">
                      <!-- <el-tooltip class="item" effect="light" content="申请船舶退会" placement="top-start" v-show="scope.row.ship_id !== null && scope.row.status === 1">
                        <el-button type="text" @click="handleShipQuit(scope.row)"><i class="el-icon-s-release"></i></el-button>
                      </el-tooltip> -->
                      <el-tooltip class="item" effect="light" content="充值" placement="top-start" v-show="['已退会', '已转让'].indexOf(scope.row.status_name) === -1 && $perm(['member.account_recharge'])">
                        <el-button type="text" @click="handleRecharge(scope.row)"><i class="el-icon-plus"
                            ></i></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="light" content="支出" placement="top-start" v-show="['已退会', '已转让'].indexOf(scope.row.status_name) === -1 && $perm(['member.account_expend'])">
                        <el-button type="text" @click="handleExpend(scope.row)"><i class="el-icon-minus"
                          ></i></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="light" content="查看账户明细" placement="top-start">
                        <el-button type="text" @click="handleAccountDetail(scope.row)"><i class="el-icon-s-fold"></i></el-button>
                      </el-tooltip>
                      <!-- <el-tooltip class="item" effect="light" content="退风险准备金" placement="top-start" v-show="['已退会', '已转让'].indexOf(scope.row.status_name) !== -1 && $perm(['member.account_withdraw'])">
                        <el-button type="text" @click="handleWithdraw(scope.row)"><i class="el-icon-success"></i></el-button>
                      </el-tooltip> -->
                      <el-tooltip class="item" effect="light" content="本人账户转移" placement="top-start">
                        <el-button type="text" @click="handleOurMove(scope.row)"><i class="el-icon-s-custom"></i></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="light" content="非本人账户转移" placement="top-start" v-if="scope.row.status === 1">
                        <el-button type="text" @click="handleOtherMove(scope.row)"><i
                            class="el-icon-male"></i></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="light" content="转移船舶并更名" placement="top-start" v-if="scope.row.status === 1">
                        <el-button type="text" @click="updateShipMove(scope.row)"><i
                            class="el-icon-refresh"></i></el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination-new ref="account_pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                  @updateList="getList"></pagination-new>
              </el-form-item>

            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="border-top mt-2 pt-3">
              <el-form-item>
                <el-button size="small" @click="cancelData">取消</el-button>
                <el-button v-if="opear_type == 'UpdateMember' && $perm(['member.change_member'])" size="small" type="primary" @click="updateData">保存
                </el-button>
                <el-button v-if="opear_type == 'SuccessQuitApply'" type="primary" size="small"
                  @click="handleSubmitSuccessQuit">审核通过(退会)</el-button>
                <el-button v-if="opear_type == 'SuccessApply'" type="primary" size="small"
                  @click="handleSubmit">审核通过(入会)</el-button>
                <el-button v-if="opear_type == 'SuccessApply'" type="primary" size="small"
                  @click="handleSubmitReject">审核不通过(入会)</el-button>
                <el-button v-if="opear_type == 'QuitApply'" type="primary" size="small"
                  @click="handleSubmitQuit">申请退会</el-button>
                  <el-button v-if="opear_type == 'QuitMember'" type="primary" size="small"
                  @click="handleSubmitApplyAgain">重新申请入会</el-button>
                <template v-if="pageStatus == 'action.add' && $perm(['customer.add_customer'])">
                  <el-button size="small" type="primary" @click="createData(1)">保存</el-button>
                  <el-button size="small" type="primary" @click="createData(2)">保存并新增</el-button>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-dialog :visible.sync="SuggestionVisible" width="50%">
            <el-form ref="refuse_reason" :model="refuse_reason" label-width="120px">
              <el-form-item label="拒绝原因" width="50%">
                <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addMessage">确 定</el-button>
            </span>
        </el-dialog>
        <upload-dialog ref="upload" :object-name="new_customer.name" :file-type-list="file_type_list"
          object-type="member.member" :object-id="new_customer.id" :is-upload="is_upload" :append-to-body="true" :customer-list="customerList"
          :default-issue-date.sync="default_issue_date" :default-expire-date.sync="default_expire_date" 
          @appended="handleAppended" @uploaded="loadFileList('member.member', new_customer.id)">
        </upload-dialog>
        <el-dialog :visible.sync="RechargeVisible" width="50%">
          <el-form ref="expend" :model="expend" label-width="120px">
            <el-form-item label="请输入充值原因" width="50%">
              <el-input v-model="recharge.reason"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="recharge" :model="recharge" label-width="120px">
            <el-form-item label="请输入充值金额" width="50%">
              <el-input type="number"  v-model="recharge.account"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="Recharge">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="shipQuitVisible" width="50%">

          <el-form ref="quit_reason" label-width="140px">
            <el-form-item prop="invoice_type" label="是否退风险准备金">
              <el-radio v-model="is_account" :label=1 >是</el-radio>
              <el-radio v-model="is_account" :label=0 >否</el-radio>            
            </el-form-item>
            <el-form-item label="业务归属部门" prop="business_area">
                <el-select v-model="business_area" placeholder="请选择部门" filterable value-key="id"  style="width: 48%;">
                <el-option v-for="g in groupList" :key="g.id"
                    :label="g.name" :value="g.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="风险准备金发票状态" prop="invoice_type">
                <el-select v-model="invoice_type" placeholder="发票状态" filterable value-key="id"  style="width: 48%;">
                <el-option v-for="g in invoice_type_list" :key="g.id"
                    :label="g.name" :value="g.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="请输入退会原因" width="50%">
              <el-input type="textarea"  :rows="10" v-model="quit_reason"></el-input>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleShipQuitApply">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="ExpendVisible" width="50%">
          <el-form ref="expend" :model="expend" label-width="120px">
            <el-form-item label="请输入支出原因" width="50%">
              <el-input v-model="expend.reason"></el-input>
            </el-form-item>
          </el-form>
          <el-form ref="expend" :model="expend" label-width="120px">
            <el-form-item label="请输入支出金额" width="50%">
              <el-input type="number" v-model="expend.account"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="Expend">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="InfolistVisible" width="60%">
          <el-table :data="ListDate" border style="width: 70%">
            <el-table-column prop="create_time" label="日期" width="180">
            </el-table-column>
            <el-table-column prop="amount" label="金额" width="180">
            </el-table-column>
            <el-table-column prop="operation_type" label="类型" width="180">
            </el-table-column>
            <el-table-column prop="creator_name" label="创建人">
            </el-table-column>
          </el-table>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="InfolistVisible = false">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="ourMoveVisible" width="50%">
          <el-form ref="recharge" label-width="120px" label="请选择要转移的账户">
            <el-form-item label="选择账户" label-width="120px">
              <el-select class="filter-item" v-model="our_move_account" filterable placeholder="请选择要转移的账户">
                <el-option v-for="(type, index) in accounts" :key="index" :label="type.ship_name + ':' + type.account" :value="type.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="转移金额" width="50%">
              <el-input type="number" v-model="our_move_balance"></el-input>
            </el-form-item>

            <el-form-item label="备注" width="50%">
              <el-input v-model="our_move_remark"></el-input>
            </el-form-item>
 
          <el-form-item label="业务归属部门" prop="other_member">
              <el-select placeholder="请选择业务部门" v-model="our_move_department" filterable clearable @change="handleSearch">
                <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="OurMove">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="otherMoveVisible" width="50%">
          <el-form ref="recharge" label-width="120px" label="请选择要转移的账户">
            <el-form-item label="会员信息" prop="other_member">
              <el-select v-model="other_member" placeholder="请选择会员" filterable value-key="id" remote
                :remote-method="remoteCustomerMethod" :loading="customer_loading">
                <el-option v-for="c in members" :key="c.id" :label="c.name" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务归属部门" prop="other_member">
              <el-select placeholder="请选择业务部门" v-model="department" filterable clearable @change="handleSearch">
                <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="otherMoveOnly">转让船舶</el-button>
            <el-button type="primary" @click="otherMove">转让船舶与账户</el-button>
          </span>
        </el-dialog>

        <el-dialog :visible.sync="updateMoveVisible" width="50%">
          <el-form ref="move_form" label-width="120px" label="请选择要转移的账户">
            <el-form-item label="会员信息" prop="other_member">
              <el-select v-model="move_form.member" placeholder="请选择会员" filterable value-key="id" remote
                :remote-method="remoteCustomerMethod" :loading="customer_loading">
                <el-option v-for="c in members" :key="c.id" :label="c.name" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
   

            <el-form-item label="船舶信息" prop="ship">
                  <el-select v-model="move_form.new_ship" placeholder="请选择转让后船舶" filterable
                      value-key="id" remote :remote-method="remoteShipMethod"
                      :loading="ship_loading">
                      <el-option v-for="s in ships" :key="s.id" :label="s.name" :value="s.id">
                      </el-option>
                  </el-select>
                  <!--<span style="margin-left: 60px">缴费总吨：{{ form.pay_gross_ton }}</span>-->
              </el-form-item>

        
            <el-form-item label="业务归属部门" prop="other_member">
              <el-select placeholder="请选择业务部门" v-model="move_form.department" filterable clearable @change="handleSearch">
                <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
              </el-select>
            </el-form-item>
    
            <el-form-item label="请输入支出金额" width="30%">
              <el-input type="number" v-model="move_form.account"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="otherMoveAndUpdate">转让并更名</el-button>
          </span>
        </el-dialog>

      </el-tab-pane>
      <el-tab-pane :label="tabLabel.attach" name="attach">
          <el-row class="py-1">
            <!-- <el-col>
              <el-button type="primary" @click="handleSelectionChange">制作文书</el-button>
            </el-col> -->
            <el-col>
              <file-sign-list :attachments="not_cc_file_list" object_type="member.member" :object_id="new_customer.customer"></file-sign-list>
            </el-col>
          </el-row>
          <make-document-dialog ref="makeDocument"
              :command_list="command_list"
              :data="multipleSelection">
          </make-document-dialog>
          <el-dialog title="选择文书类型" :visible.sync="outerVisible" :show-close="false">
            <el-checkbox-group v-model="command_list">
              <el-checkbox v-for="item in command_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCancel">取 消</el-button>
              <el-button type="primary" :disabled="command_list.length === 0" @click="openBatchExport">开始制作文书</el-button>
            </div>
          </el-dialog>
          <el-dialog title="签署人选择" :visible.sync="dialogFormVisible" :show-close="false">
            <el-form>
              <el-form-item label="签署人">
                <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
                  <el-option v-for="contact in contacts" :key="contact.id" :label="contact.name + '(' + contact.mobile + ')'" :value="contact.mobile"></el-option>
                </el-select>
              </el-form-item>企业会员入会申请书
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCancelSend">取 消</el-button>
              <el-button :disabled="signer_mobile === ''" type="primary" @click="sendSign">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog :title="pdfname" :visible.sync="previewVisible">
            <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
          </el-dialog>
        </el-tab-pane>
    </el-tabs>
  </el-card>

  </div>
</template>
<script>
import { uploadFile,uploadChildFile} from "@/api/upload";
import PaginationNew from '@/components/PaginationNew'
import { fetchList as fetchGroupList } from "@/api/group";
import { validateMobileNumber, isValidMobileNumber } from '@/utils/validate'
import { createCustomer,fetchCustomerContactList } from '@/api/customer'
import { fetchDictList, fetchFileTypeList, fetchInsuranceObjectFileList } from '@/api/common'
import UploadingList from "@/components/UploadingList";
import { fetchShipNameList } from '@/api/ship'
import FileSignList from '@/components/FileSignListDetail'
import { fetchFileList } from "@/utils";
import { deleteFile,signFile} from '@/api/sign'
import {download} from '@/utils'
import { formatSize } from '@/utils/misc'
import AttachmentList from "@/components/AttachmentList";
import MakeDocumentDialog from '../../ib/group-insurance/make-document-dialog'
import UploadDialog from "@/components/UploadDialog";
import { GetShipInfo } from '../../../api/group-insurance';
import VuePdfPreview from "@/components/VuePdfPreview"
import {
  CreateMember, fetchMember, updateMember, applyMember, quitMember, rejectMember,ApplyAgain,memberShipQuitApply,
  successQuitMember, getAccountList, QuitShipApply, AccountRecharge, AccountExpend,createAccountApply,
  AccountWithdraw, AccountDetail, getMemberList, ourAccountMove, otherAccountMove, checkCustomer, checkMember
} from '@/api/member'

export default {
  name: "detail",
  components: {
    UploadingList,
    AttachmentList,
    UploadDialog,
    PaginationNew,
    VuePdfPreview,
    MakeDocumentDialog,
    FileSignList
  },
  computed: {
    attachment_name: function () {
      let name = this.new_customer.name ? this.new_customer.name : "附件";
      return (name + ".zip");
    }
  },
  filters: {
    formatSize
  },
  data() {
    var contactFillingStatus = () => {
      let mobile = ''
      if (this.new_customer.mobile !== undefined && this.new_customer.mobile !== null && this.new_customer.mobile !== '') {
        mobile = this.new_customer.mobile.trim()
      }

      let contact = ''
      if (this.new_customer.contact !== undefined && this.new_customer.contact !== null && this.new_customer.contact !== '') {
        contact = this.new_customer.contact.trim()
      }

      let contact_mobile = this.new_customer.contact_mobile;
      if (contact_mobile !== null && contact_mobile !== undefined && contact_mobile !== '') {
        contact_mobile = contact_mobile.trim()
      } else {
        contact_mobile = ''
      }

      let contact_wechat = this.new_customer.contact_wechat;
      if (contact_wechat !== null && contact_wechat !== undefined && contact_wechat !== '') {
        contact_wechat = contact_wechat.trim()
      } else {
        contact_wechat = ''
      }

      // console.log('mobile: ' + mobile)
      // console.log('contact: ' + contact)
      // console.log('contact_mobile: ' + contact_mobile)
      // console.log('contact_wechat: ' + contact_wechat)

      if (mobile === '' && contact === '') {
        // 没有填写会员手机, 也没填写联系人
        return 'ALL_BLANK'
      } else if (mobile !== '') {
        // 填写了会员手机号
        return 'FILLED_MOBILE_ONLY'
      } else if (mobile === '' && contact !== '' && contact_mobile === '' && contact_wechat === '') {
        // 填写了联系人以及联系人手机
        return 'FILLED_CONTACT_ONLY'
      } else if (mobile === '' && contact !== '' && contact_mobile !== '') {
        // 填写了联系人以及联系人手机
        return 'FILLED_CONTACT_WITH_MOBILE'
      } else if (mobile === '' && contact !== '' && contact_wechat !== '') {
        // 填写了联系人以及联系人微信
        return 'FILLED_CONTACT_WITH_WECHAT'
      } else {
        return 0
      }
    };

    var checkMobile = (rule, value, callback) => {
      let status = contactFillingStatus()
      switch (status) {
        // case 'ALL_BLANK':
        //   return callback(new Error('无法获取会员手机号,则需要填写联系人以及联系人手机或微信号'));
        //   break;
        case 'FILLED_MOBILE_ONLY':
          if (!isValidMobileNumber(value)) {
            return callback(new Error('手机格式不正确'))
          }
          return callback();
          break;
        default:
          return callback()
      }
    };

    var checkContact = (rule, value, callback) => {
      let status = contactFillingStatus()
      switch (status) {
        case 'FILLED_CONTACT_ONLY':
          return callback(new Error('联系人手机号或微信号需要至少填写一项'));
          break;
        default:
          return callback()
      }
    };

    var checkContactPersonMobile = (rule, value, callback) => {
      let status = contactFillingStatus()
      switch (status) {
        case 'FILLED_CONTACT_WITH_MOBILE':
          if (!isValidMobileNumber(value)) {
            return callback(new Error('手机格式不正确'))
          }
          return callback()
          break;
        default:
          return callback()
      }
    };

    var checkEmail = (rule, value, callback) => {
      if (value != null) { 
        var reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if(!reg.test(value)){
          return callback(new Error('请输入有效的邮箱'));
        }
      }
      return callback()
    };


      var checkCertNumber = (rule, value, callback) => {
        if (this.new_customer.cert_type !== 'cc_id_card'){
          return callback()
        }
        if (!value) {
          return callback(new Error('身份证号码不能为空'));
        }

          var msg, boo; //  msg身份证验证友情提示,boo返回值
          var value = value.toUpperCase(); // 身份证为末尾可能是X
          //   身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，
          //   最后一位是校验位，可能为数字或字符X。
          const arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
          const arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
          var nTemp = 0,
            i;
          if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
            //  输入的身份证号长度不对，或者号码不符合规定;
            return callback(new Error('输入的身份证号长度不对，或者号码不符合规定'))
          }
          //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
          //   下面分别分析出生日期和校验位
          var len, re;
          len = value.length;
          if (len == 15) {
            re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
            var arrSplit = value.match(re);
            //   检查生日日期是否正确
            var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
            var bGoodDay;
            bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
            if (!bGoodDay) {
              //   输入的身份证号里出生日期不对！
              return callback(new Error('输入的身份证号里出生日期不对！'))

            } else {
              //   将15位身份证转成18位
              //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。   
              value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
              for (i = 0; i < 17; i++) {
                nTemp += value.substr(i, 1) * arrInt[i];
              }
              value += arrCh[nTemp % 11];
              return callback()
            }
          }
          if (len == 18) {
            re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
            var arrSplit = value.match(re);
            //  检查生日日期是否正确
            var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
            var bGoodDay;
            bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
            if (!bGoodDay) {
              //  输入的身份证号里出生日期不对！ 

              return callback(new Error('输入的身份证号里出生日期不对！'))
            } else {
              //  检验18位身份证的校验码是否正确。
              //  校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
              var valnum;
              for (i = 0; i < 17; i++) {
                nTemp += value.substr(i, 1) * arrInt[i];
              }
              valnum = arrCh[nTemp % 11];
              if (valnum != value.substr(17, 1)) {
                //  18位身份证的校验码不正确！
                return callback(new Error('身份证的校验码不正确！'))
              }
              return callback()
            }
          }
          return callback(new Error('身份证的长度不正确！'))
      };



    var checkCustomName = (rule, value, callback) => {
      var reg = new RegExp("[`~!@#$^&*=|{}':;',\\[\\].<>/?~！@#￥……&*——|{}【】‘；：”“'。，、？]", "g")

      if (value == undefined || value == null || value == "") {
        return callback(new Error("请输入会员名称"))
      }
      else if (this.new_customer.type == 1 && value.length > 4) {
        return callback(new Error("个人名称不得超过4个字"))
      }
      else if (this.new_customer.type == 0 && value.length < 5) {
        return callback(new Error("请输入公司全称"))
      }
      else if (reg.test(value)) {
        return callback(new Error("名称不能含有特殊字符"))
      }
      else {
        return callback()
      }
    };

    return {
      rules: {
        name: [{ required: true, trigger: 'blur', validator: checkCustomName }],
        type: [{ required: true, message: '请选择会员类型', trigger: 'blur' }],
        cert_type: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        cert_number: [{required: true, validator: checkCertNumber, trigger: 'blur'}],
        mobile: [{ validator: checkMobile, trigger: 'blur' }],
        contact: [{ validator: checkContact, trigger: 'blur' }],
        contact_mobile: [{ validator: checkContactPersonMobile, trigger: 'blur' }],
        email: [{validator: checkEmail, trigger: 'blur'}],
        // actual_controller: [{required: true, message: '请输入实际控制人信息', trigger: 'blur'}],
        // contact: [{required: true, message: '请输入联系人信息', trigger: 'blur'}],
      },
      loading: false,
      loadingText: '正在加载数据，请销等...',
      new_customer: {
        name: '',
        type: '0',
        cert_type: null,
        mobile: '',
        contact: '',
        contact_mobile: '',
        contact_wechat: '',
      },
      accounts: [],
      member: [],
      groupList:[],
      customerList:[],
      invoice_type:null,
      invoice_type_list:[
        {'id':1,'name':'未开具发票'},
        {'id':2,'name':'冲红发票'},
        {'id':3,'name':'扣税点'},
      ],
      department:null,
      business_area:'',
      multipleSelection: [],
      tabLabel: {
          basic: "基本信息",
          attach: "附件",

        },
      command_options: [
        {value: 'one', label: '企业会员入会申请书'}, 
        {value: 'two', label: '个人会员入会申请书'}, 
        {value: 'three', label: '船舶入会申请书'}, 
        {value: 'four', label: '缴费通知书'}, 
        {value: 'five', label: '活动参加申请书'}, 
        {value: 'six', label: '互助保障活动说明书'}, 
        {value: 'seven', label: '互助保障活动说明书（附加4项）'}
      ],
      activeName:'basic',
      is_upload: false,
      ship_type_list: [],
      our_move_account: null,
      move_and_update_member:null,
      SuggestionVisible:false,
      shipQuitVisible:false,
      refuse_reason:"",
      other_member: null,
      is_account:1,
      quit_reason:'',
      our_move_department:null,
      file_id: '',
      apply_ships: [],
      command_list: [],
      file_type_list: [],
      attachments:[],
      ship_info: [],
      searching: false,
      multipleSelectionAccount:[],
      type_list: [],
      select_ship_info: {},
      recharge: {
        'account':0,
        'reason':null
      },
      opera_type: "",
      members: [],
      contacts: [],
      expend: {
        'account':0,
        'reason':null
      },
      move_form:{
        'account':0,
        'member':null,
        'new_ship':null,
        'department':null
      },
      count_:1,
      file: {},
      ListDate: [],
      InfolistVisible: false,
      info_form: {},
      InfoVisible: false,
      signer_mobile: '',
      previewVisible:false,
      file_list: [],
      cc_file_list:[],
      not_cc_file_list:[],
      account_info: [],
      gender_list: [],
      pageStatus: '',
      default_issue_date: '',
      default_expire_date: '',
      tagInputVisible: false,
      our_move_balance:0,
      our_move_remark:"",
      RechargeVisible: false,
      outerVisible:false,
      ExpendVisible: false,
      ourMoveVisible: false,
      otherMoveVisible: false,
      dialogFormVisible:false,
      updateMoveVisible:false,
      customer_loading: false,
      control_riskamount: false,
      tagValue: '',
      ship_loading: false,
      id: null,
      opear_type: '',
      pdfname: '',
      pdfUrl: '',
      total: 0,
      ships: [],
      airworthiness_area_list: [],
      form: {
        ship: '',
        name: ''
      },
      query: {
        search: '',
        offset: 0,
        limit: 20,

      },
      pickerOptions: {
        shortcuts: [{
          text: '长期',
          onClick(picker) {
            const date = new Date('9999-01-01');
            // date.setFullYear(date.getFullYear() + 200);
            picker.$emit('pick', date);
          }
        }]
      },
    }
  },
  methods: {
    handleShipQuitApply(){
      if (!this.business_area) {
          this.$message.error('请选择业务部门')
          return
        }
      if (!this.invoice_type) {
          this.$message.error('请选择风险准备金发票状态')
          return
        }

      memberShipQuitApply({ 'apply_ships': this.multipleSelectionAccount,'member_id':this.id,'is_account':this.is_account,'quit_reason':this.quit_reason,'department':this.business_area,'invoice_type':this.invoice_type })
        .then(resp => {
          this.$message({
            type: 'success',
            message: '提交申请成功！'
          });
          this.shipQuitVisible = false
          this.business_area = null
          this.$router.push({ name: 'quitShipApplyList' })   
          // this.AccountList()
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    download,
    // loadFileList(object_type, object_id) {
    //   fetchFileList(object_type, object_id, this.file_type_list)
    //     .then(res => {
    //       this.file_list = res.file_list;
    //       this.file_list.forEach(item => {
    //         this.$set(item, 'checked', true)
            
    //       })
    //       // this.default_issue_date = res.def_issue_date;
    //       // this.default_expire_date = res.def_expire_date;
    //     })
    //     .catch(error => {
    //       this.$error_message(error);
    //     });
    // },
    handleSubmitShipQuitApply(){
      let not_status = []
      this.multipleSelectionAccount.forEach(item => {
            if (item.status !== 1 && item.status !== 10  && item.status !== 4){
              not_status.push(item.id)
            }
          })
      if (not_status.length > 0){
        this.$error_message("您选择的船舶有状态不是为已绑定或者已转让或已退会的，请检查！")
            return
      }
      this.shipQuitVisible = true
    },
    handleSubmitApplyAgain(){
      this.$confirm('是否确认重新提交入会审核?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        ApplyAgain({ 'id': this.id })
        .then(resp => {
          this.$message({
            type: 'success',
            message: '提交申请成功！'
          });
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
      })
    
    },
    handleCancel() {
      this.command_list = []
      this.outerVisible = false
    },
    openBatchExport() {
      // 已弃用
      this.$refs.makeDocument.handleMake()
    },
    handleSelectionChangeAccount(val) {
          this.multipleSelectionAccount = val;     
        },
    handleSelectionChange(val) {
      this.outerVisible = true
      // 根据客户类型选择个人入会申请 or 企业入会申请

    },
    reset_commands() {
      return [
        {value: 'one', label: '企业会员入会申请书'}, 
        {value: 'two', label: '个人会员入会申请书'}
      ]
    },
    sendSign() {
      const text = '是否发送文书' + '《' + this.file.name + '》至' + this.signer_mobile + '进行签署？'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(this.file, 'signer_mobile', this.signer_mobile)

        signFile(this.file)
        .then(res => {
          // console.log(res)
          this.$message({
            type: 'success',
            message: '已通知手机号为: ' + this.signer_mobile + ' 的客户进行签署'
          });
        })
        .catch((err) => {
          this.$message.error({
            message: err
          });
        })

        this.dialogFormVisible = false
        this.loadData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消发送签署'
        });       
      });
    },
    previewPdf(file){
      this.pdfname = file.name
      this.pdfUrl = file.url
      this.previewVisible = true
    },
    showDialog(row) {
      this.dialogFormVisible = true
      this.file = row
    },
    handleCancelSend() {
      this.dialogFormVisible = false
      this.signer_mobile = ''
      this.file = {}
    },
    handleUploadFile(param) {
      let file = param.file
      let fd = new FormData()

      fd.append("file", file)
      fd.append("object_id", this.customerid)
      fd.append("object_type", "member.member")
      fd.append("new_name", file.name)
      fd.append("org_file_id", this.file_id)
      // console.log(fd)
      uploadChildFile(fd)
        .then(res => {
          param.onSuccess(res)
          this.loadData()
        })
        .catch(error => {
          param.onError(error)
          error_message(error)
        })
    },
    canSend(row) {
      let can = false
      if (row.file_sign.length == 0) {
        can = true
      }
      else if (! row.file_sign[0].receiver) {
        can = true
      }
      return can
    },
    handleDelete(row) {
      this.apply_ships = this.apply_ships.filter(ship => {
        return ship.id !== row.id
      })
    },
    handleDeleteAtt(row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        deleteFile({'id': row.id,'type':'member.member'}).then(res => {
          this.loading = false
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          let not_cc_file_list = []
          this.not_cc_file_list.forEach((i,index)=>{
                    if(i.id!==row.id){
                      not_cc_file_list.push(i)
                }
                })
          this.not_cc_file_list = not_cc_file_list
        }).catch(err => {
          this.loading = false
          this.$error_message(err)
        })
      })
    },
    addAppShip() {
            let ship = this.ships.find((a) => { return a.id === this.form.ship })
            let dict_ = { 'id': ship.id, 'name': ship.name }
            let ship_obj_id = dict_.id
            let count = 0
            this.apply_ships.forEach((i,index)=>{
                    if(i.id==ship_obj_id){
                    this.$message.error(i.name + "已经添加过了")
                    count = 1
                }
                })
            if (count == 0){
                this.apply_ships.push(dict_)
            }          
            },
    handleShipInfo(item) {
      this.getShipInfoDetail()
    },
    getShipInfoDetail() {
      let form_data = JSON.parse(JSON.stringify(this.form))
      GetShipInfo({ 'ship': form_data.ship })
        .then(resp => {
          this.select_ship_info = resp.result
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
    },
    getList() {
      this.AccountList()
    },
    remoteCustomerMethod(query) {
      if (query !== '') {
        this.customer_loading = true
        setTimeout(() => {
          getMemberList({ "search": query, "status": 1 }).then(res => {
            this.members = res
            this.customer_loading = false
          }).catch(err => {
            this.customer_loading = false
            this.$error_message(err)
          })
        }, 200);
      } else {
        this.members = [];
      }
    },
    otherMoveAndUpdate(){
      if (this.move_form.member === null) {
        this.$error_message("请先选择要接收的会员！")
        return
        }
      if (this.move_form.department === null) {
        this.$error_message("请先选择业务归属部门！")
        return
        }
      if (this.move_form.new_ship === null) {
        this.$error_message("请先选择更改后的船舶！")
        return
        }
      otherAccountMove({ recipient_id: this.move_form.member, member_id: this.id, ship: this.other_move_ship, account: this.other_move_account, balance: this.move_form.account,new_ship:this.move_form.new_ship,department:this.move_form.department})
        .then(res => {
          this.$message.success(res)
          this.updateMoveVisible = false
          this.AccountList()
        })
        .catch(err => {
          this.$error_message(err)
        })
    },
    otherMoveOnly() {
      if (this.other_member === null) {
        this.$error_message("请先选择要接收的会员！")
        return
        }
      if (!this.department) {
          this.$message.error('请选择业务部门')
          return
        }
      otherAccountMove({ recipient_id: this.other_member, member_id: this.id, ship: this.other_move_ship, account: this.other_move_account, balance: 0,department:this.department})
        .then(res => {
          this.$message.success(res)
          this.otherMoveVisible = false
          this.AccountList()
        })
        .catch(err => {
          this.$error_message(err)
        })
    },
    otherMove() {
      if (this.other_member === null) {
        this.$error_message("请先选择要接收的会员！")
        return
        }
      if (!this.department) {
          this.$message.error('请选择业务部门')
          return
        }
      otherAccountMove({ recipient_id: this.other_member, member_id: this.id, ship: this.other_move_ship, account: this.other_move_account, balance: this.other_move_money,department:this.department})
        .then(res => {
          this.$message.success(res)
          this.otherMoveVisible = false
          this.AccountList()
        })
        .catch(err => {
          this.$error_message(err)
        })
    },
    handleOtherMove(row) {
      this.otherMoveVisible = true
      this.other_move_ship = row.ship_id
      this.other_move_account = row.id
      this.other_move_money = row.balance
    },
    updateShipMove(row){
      this.updateMoveVisible = true
      this.other_move_ship = row.ship_id
      this.other_move_account = row.id
    },
    OurMove() {
      if (this.our_move_account === null) {
        this.$error_message("请先选择要接收的账户！")
        return
        }
      if (!this.our_move_department) {
        this.$message.error('请选择业务部门！')
        return
      }
      if (this.our_move_balance  > this.move_balance) {
        this.$error_message("转移金额不能大于账户余额！")
        return
        }
        if (this.our_move_account  === this.move_account_id) {
        this.$error_message("不能转给同一账户！")
        return
        }
        createAccountApply({member_id:this.id, recipient_account_id: this.our_move_account, account_id: this.move_account_id, balance: this.our_move_balance,content:this.our_move_remark,department:this.our_move_department })
        .then(res => {
          this.ourMoveVisible = false
          this.$message.success("创建成功")
          this.AccountList()
        })
        .catch(err => {
          this.$error_message(err)
        })
    },
    handleOurMove(row) {
      getAccountList({ 'id': this.id }).then(res => {
        this.accounts = res
      })
      this.move_account_id = row.id
      this.move_balance = row.balance
      this.ourMoveVisible = true
    },
    handleAccountDetail(row) {
      AccountDetail({ id: row.id })
        .then(res => {
          this.ListDate = res
        })
        .catch(err => {
          this.$error_message(err)
        })
      this.InfolistVisible = true
    },
    handleChange(val) {
      this.infoquery.offset = (this.msginfopage - 1) * this.infoquery.limit;
      this.getMessageInfoList(1);
    },

    handleWithdraw(row) {
      this.$confirm('是否提现?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        AccountWithdraw({ id: row.id })
          .then(res => {
            this.$message.success(res)
            this.AccountList()
          })
          .catch(err => {
            this.$error_message(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提现'
        });
      });
    },
    Expend() {
      this.expend.id = this.select_account
      AccountExpend(this.expend)
        .then(res => {
          this.$message.success(res)
          this.AccountList()
          this.expend = {}
        })
        .catch(err => {
          this.$error_message(err)
        })

      this.ExpendVisible = false
    },
    handleExpend(row) {
      this.ExpendVisible = true
      this.select_account = row.id
    },
    Recharge() {
      this.recharge.id = this.select_account
      AccountRecharge(this.recharge)
        .then(res => {
          this.$message.success(res)
          this.AccountList()
          this.recharge = {}
        })
        .catch(err => {
          this.$error_message(err)
        })
      this.RechargeVisible = false

    },
    handleRecharge(row) {
      this.RechargeVisible = true
      this.select_account = row.id
    },
    handleShipQuit(row) {
      this.$confirm('是否申请退会?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        QuitShipApply({ id: row.id })
          .then(res => {
            this.$message.success(res)
            this.AccountList()
          })
          .catch(err => {
            this.$error_message(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },
    handleSearch() {
      this.$refs.account_pagination.backNumOne()
    },
    AccountList() {
      this.query.id = this.id
      this.searching = true
      getAccountList(this.query).then(res => {
        this.searching = false
        this.ship_info = res.results
        this.total = res.count
      }).catch(err => {
        this.searching = false
        this.$error_message(err)
      })
    },
    addMessage(){
  this.$confirm('是否核对会员资料并且拒绝该会员入会?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rejectMember({ id: this.id,refuse_reason:this.refuse_reason })
          .then(res => {
            this.$message.success(res)
            this.SuggestionVisible = false
            this.$router.push({ name: 'applyList' })
          })
          .catch(err => {
            this.$error_message(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },
    handleSubmitReject() {
      this.SuggestionVisible = true
    
    },
    handleSubmitQuit() {
      this.$confirm('是否申请退会?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        quitMember({ id: this.id })
          .then(res => {
            this.$message.success(res)
            this.$router.push({ name: 'memberList' })
          })
          .catch(err => {
            this.$error_message(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消申请'
        });
      });
    },
    handleSubmitSuccessQuit() {
      this.$confirm('是否核对会员资料并且通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        successQuitMember({ id: this.id })
          .then(res => {
            this.$message.success(res)
            this.$router.push({ name: 'quitApplyList' })
          })
          .catch(err => {
            this.$error_message(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },
    handleSubmit() {

      checkMember({ id: this.id }).then(res => {
        if (res.count === 1) {
          var msg = '检测到该客户已经是会员了，是否共享 ？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            applyMember({ id: this.id })
              .then(res => {
                this.$message.success(res)
                this.$router.push({ name: 'applyList' })
              })
              .catch(err => {
                this.$error_message(err)
              })
          })
        }
        else {
          this.$confirm('是否核对会员资料并且通过审核?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            applyMember({ id: this.id })
              .then(res => {
                this.$message.success(res)
                this.$router.push({ name: 'applyList' })
              })
              .catch(err => {
                this.$error_message(err)
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消审核'
            });
          });
        }
      })
        .catch(err => {
          this.$error_message(err)
        })




    },
    reset_new_customer() {
      this.new_customer = {}
    },
    handleNameChange() {
      if (this.pageStatus === 'action.add') {
        this.file_list.forEach(item => {
          let new_name, new_name_parts = item.new_name.split("-")
          new_name_parts[0] = this.new_customer.name
          new_name = new_name_parts.join("-")
          this.$set(item, 'new_name', new_name)
        })
      }
    },
    // handleTagRemove(tag) {
    //   let tag_list = this.new_customer.tag_list
    //   tag_list.splice(tag_list.indexOf(tag), 1)
    //   this.$set(this.new_customer, 'tag_list', tag_list)
    // },
    // showTagInput() {
    //   this.tagInputVisible = true
    //   this.$nextTick(_ => {
    //     this.$refs.tagInput.$refs.input.focus()
    //   });
    // },
    // handleInputConfirm() {
    //   let tagValue = this.tagValue, tag_list = this.new_customer.tag_list
    //   if (tagValue) {
    //     tag_list.push(tagValue)
    //     this.$set(this.new_customer, 'tag_list', tag_list)
    //   }
    //   this.tagInputVisible = false
    //   this.tagValue = ''
    // },
    handleCreate() {
      this.pageStatus = 'action.add'
      this.is_upload = false
      this.loadData()
    },
    handleUpdate(id) {
      this.pageStatus = 'action.edit'
      this.is_upload = true
      this.loadData()
      fetchMember(id)
        .then(res => {
          this.new_customer = Object.assign({}, res)
          let customer_obj = {"id":this.new_customer.customer,"name":this.new_customer.name}
          this.customerList.push(customer_obj)
          
          // 处理扩展字段
          if (JSON.stringify(this.new_customer.ext_info) !== "{}") {
            Object.keys(this.new_customer.ext_info).forEach(key => {
              this.$set(this.new_customer, key, this.new_customer.ext_info[key])
            })
            this.new_customer.ext_info = undefined
          }

          if (!this.new_customer.tag_list) {
            this.$set(this.new_customer, 'tag_list', [])
          }

          this.loadFileList("member.member", this.new_customer.id)
          fetchCustomerContactList(this.new_customer.customer)
            .then(res => {
              this.contacts = res
            })
            .catch(err => {
              console.log(err)
            })

          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate()
          })
        })
        .catch(error => {
          this.$message.error(error)
        })

    },
    handleOpen() {
      this.$refs.upload.handleOpen()
    },
    loadFileList(object_type, object_id) {
      this.count_ += 1

      let file_type_cc_list = ['cc_id_card','cc_org_code','cc_tax_reg','cc_business_reg','cc_business_license','cc_other']
      fetchInsuranceObjectFileList(object_type, object_id)
        .then(res => {
          this.file_list = res
          if (this.not_cc_file_list.length !== 0){
              this.not_cc_file_list = []
            }
          this.file_list.forEach(item => {
            let file_type_obj = this.file_type_list.find(type => {
              return (type.code === item.file_type)
            })
            if (file_type_obj && item.file_date) {
              if (file_type_obj.date_type === 'F') {
                this.default_issue_date = item.file_date
              } else {
                this.default_expire_date = item.file_date
              }
            }
            if ( this.count_ === 3){
              if(file_type_cc_list.includes(item.file_type)){
                this.cc_file_list.push(item)
              }
              else{
                this.not_cc_file_list.push(item)
            }
            }
          })
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    loadData() {
      if (this.opear_type !== 'CreateShipApply') {
        this.loadFileList('member.member', this.id)
      }

      let p1 = fetchDictList({ type: 'customer.type' })
      let p2 = fetchFileTypeList({ file_type: 'cc|bc' })
      let p3 = fetchDictList({ type: 'customer.gender' })
      let p4 = fetchDictList({ type: "ship.airworthiness_area" })
      let p5 = fetchDictList({ type: "ship.type" })
      let p6 = fetchGroupList({type:"group_apply"})

      this.loading = true
      Promise.all([p1, p2, p3, p4, p5, p6])
        .then(res => {
          if (res[0] !== null || res[0] !== undefined) {
            this.type_list = [{ "code": null, "value": "请选择客户类型" }].concat(res[0])
          }
          this.file_type_list = res[1]
          this.gender_list = res[2]
          this.airworthiness_area_list = res[3]
          this.ship_type_list = res[4]
          this.groupList = res[5]
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
    },
    cancelData() {
      this.$refs.dataForm.resetFields()
      this.reset_new_customer()
      if (this.opear_type === 'QuitMember') {
        this.$router.push({ name: 'quitList' })
      }
      else if (this.opear_type === 'SuccessApply') {
        this.$router.push({ name: 'applyList' })
      }
      else if (this.opear_type === 'SuccessQuitApply') {
        this.$router.push({ name: 'quitApplyList' })
      }
      else {
        this.$router.push({ name: 'memberList' })
      }

    },
    createData(type) {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          // this.$message.success('保存会员信息成功!')
          // return 
          let proArr = []
          this.loading = true
          this.loadingText = '正在创建会员数据，请稍等...'
          this.new_customer.apply_ships = this.apply_ships
          checkCustomer(this.new_customer).then(res => {
            createCustomer(this.new_customer)
              .then(res => {
                this.$message.success('创建客户成功')
                this.new_customer.customer_id = res.id
                CreateMember(this.new_customer)
                  .then(res => {
                    this.customerid = res.id
                    this.loadingText = "保险会员信息成功，上传会员相关附件，请稍等..."

                    this.file_list.forEach(item => {
                      let file = item.raw, fd = new new_customer()
                      fd.append("file", file)
                      fd.append("object_id", this.customerid)
                      fd.append("object_type", "member.member")
                      fd.append("file_type_code", item.file_type_code)
                      fd.append("file_date", item.file_date)
                      fd.append("new_name", item.new_name)

                      this.loadingText = "正在上传文件 [" + item.name + "]，请稍等..."
                      proArr.push(uploadFile(fd))
                    })
                    return Promise.all(proArr)
                  })
                  .then(() => {
                    this.loading = false
                    this.$message.success('保存会员信息和会员附件成功')
                    this.$nextTick(() => {
                      this.$refs.dataForm.clearValidate()
                      this.$refs.dataForm.resetFields()
                      this.reset_new_customer()
                      if (type == 1) {
                        this.$router.push({ name: 'memberList' })
                      }
                    })
                  })
                  .catch(error => {
                    this.saving = false
                    this.$message.error(error)
                  })
              }).catch(error => {
                this.$message.error(error)
                return
              })
          })
            .catch(error => {
              this.$message.error(error)
              this.loading = false
            })
        }
      })
    },
    updateData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          // this.$message.success('保存会员信息成功!')
          // return 
          const new_customer = Object.assign({}, this.new_customer)
          updateMember(new_customer.id, new_customer)
            .then(() => {
              this.$message.success('更新会员信息成功')
              this.$nextTick(() => {
                this.$refs.dataForm.clearValidate()
                this.$refs.dataForm.resetFields()
                this.reset_new_customer()
                setTimeout(() => {
                  this.$router.push({ name: 'memberList' })
                }, 2000)
              })
            })
            .catch(error => {
              this.$message.error(error)
            })
        }
        // this.$message.error('校验失败!')
      })
    },
    handleUpload() {
      this.$refs.upload.handleOpen()
    },
    handleAppended(fileList) {
      this.file_list = this.file_list.concat(fileList)
    },
    remoteShipMethod(query) {
      if (query !== '') {
        this.ship_loading = true
        setTimeout(() => {
          fetchShipNameList({ 'search': query }).then(res => {
            this.ships = res
            this.ship_loading = false
          }).catch(err => {
            this.ship_loading = false
            this.$error_message(err)
          })
        }, 200);
      } else {
        this.ships = [];
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != 'memberList') {
      window.localStorage.removeItem('query')
    }
    next()
  },
  created() {
    if (this.$route.name == 'memberCreate') {
      this.opear_type = this.$route.query.type
      this.handleCreate()
    } else {
      var id = this.$route.query.id
      this.id = this.$route.query.id
      this.opear_type = this.$route.query.type
      if (id == undefined) {
        this.$router.push('/404')
      } else {
        this.customerid = id
        this.handleUpdate(this.customerid)

      }
    }
    this.AccountList()
  }
}
</script>
  
<style scoped>
.el-row-divider {
  margin-top: 36px
}

.title {
  font-weight: bold;
}

.highlight {
  color: red;
}
</style>      